"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oriPackageJsonSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
var _OriTeam = require("./OriTeam");
var _PackageJson = require("./PackageJson");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const coverageThresholdPropsSchema = z.object({
  branches: z.number().optional(),
  functions: z.number().optional(),
  lines: z.number().optional(),
  statements: z.number().optional()
});
const coverageThresholdSchema = z.object({
  global: coverageThresholdPropsSchema.strict().optional()
}).optional();
const jestConfigSchema = z.object({
  coverageThreshold: coverageThresholdSchema
}).optional();
const oriPackageJsonSchema = exports.oriPackageJsonSchema = _PackageJson.packageJsonSchema.extend({
  source: z.string().optional(),
  jest: jestConfigSchema,
  'jest-junit': z.record(z.unknown()).optional(),
  lumos: z.object({}).optional(),
  teamName: _OriTeam.oriTeamSchema.optional(),
  packageManager: z.string().optional(),
  msw: z.object({
    workerDirectory: z.string()
  }).optional()
});
//# sourceMappingURL=OriPackageJson.js.map